import React, { Suspense } from 'react';
import { useInView } from 'react-intersection-observer';
import { useCartSelectors } from 'lib/cartState/selectors';

const LazyComponent = ({ Component, children }: { Component: React.ComponentType; children?: React.ReactNode }) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '1000px', threshold: 0.1 });
  const { LazyLoad } = useCartSelectors();

  const LoadComponent = LazyLoad || inView;
  return (
    <div ref={ref} style={{ minHeight: LoadComponent ? 0 : '1000px', opacity: LoadComponent ? 1 : 0 }}>
      {LoadComponent && (
        <Suspense fallback={<div style={{ height: '1000px', width: '100%' }}></div>}>
          <Component>{children}</Component>
        </Suspense>
      )}
    </div>
  );
};

export default LazyComponent;
